export const GameHistoryABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AccessControlBadConfirmation",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "bytes32",
        "name": "neededRole",
        "type": "bytes32"
      }
    ],
    "name": "AccessControlUnauthorizedAccount",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "newTotal",
        "type": "uint256"
      }
    ],
    "name": "PaydayFundAdded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "distributed",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "remaining",
        "type": "uint256"
      }
    ],
    "name": "PaydayFundDistributed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "squareBitmask",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amountPerSquare",
        "type": "uint256"
      }
    ],
    "name": "PlayRecorded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "PlayerStatsUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "bytes32",
        "name": "role",
        "type": "bytes32"
      },
      {
        "indexed": true,
        "internalType": "bytes32",
        "name": "previousAdminRole",
        "type": "bytes32"
      },
      {
        "indexed": true,
        "internalType": "bytes32",
        "name": "newAdminRole",
        "type": "bytes32"
      }
    ],
    "name": "RoleAdminChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "bytes32",
        "name": "role",
        "type": "bytes32"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "sender",
        "type": "address"
      }
    ],
    "name": "RoleGranted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "bytes32",
        "name": "role",
        "type": "bytes32"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "sender",
        "type": "address"
      }
    ],
    "name": "RoleRevoked",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "closingBlock",
        "type": "uint256"
      }
    ],
    "name": "RoundClosingBlockSet",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "RoundCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "totalPot",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "gameFee",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "welephantBoughtBack",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "paydayAmount",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "winningSquare",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "isPayday",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "isSingleWinner",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "singleWinner",
        "type": "address"
      }
    ],
    "name": "RoundFinalized",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "startTime",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "endTime",
        "type": "uint256"
      }
    ],
    "name": "RoundStarted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "RoundSummaryAdded",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "DAY_DURATION",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "DEFAULT_ADMIN_ROLE",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "LEADERBOARD_SIZE",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "PAYDAY_DISTRIBUTION_PERCENT",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "WRITER_ROLE",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "addPaydayFund",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "addPlayerEthSpent",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "addPlayerEthWon",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "addPlayerRoundEthWon",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "addPlayerRoundWelephantWon",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "addPlayerWelephantWon",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint40",
            "name": "roundId",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "closingBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantBoughtBack",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "paydayAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winnerPayout",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributed",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "winningSquare",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "totalPlayers",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "totalWinners",
            "type": "uint32"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          }
        ],
        "internalType": "struct GameHistoryTypes.RoundSummary",
        "name": "summary",
        "type": "tuple"
      }
    ],
    "name": "addRoundSummary",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "potAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "feeAmount",
        "type": "uint256"
      }
    ],
    "name": "addToRoundPot",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "addTotalEthPaidOut",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "addTotalWelephantPaidOut",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "currentRoundId",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "dayIndex",
        "type": "uint256"
      }
    ],
    "name": "dailyEthFees",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "dayIndex",
        "type": "uint256"
      }
    ],
    "name": "dailyPlays",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "dayIndex",
        "type": "uint256"
      }
    ],
    "name": "dailyUniquePlayers",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "dayIndex",
        "type": "uint256"
      }
    ],
    "name": "dailyWelephantBuybacks",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "distributePaydayFund",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "distributed",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getActivePlayers24h",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "count",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "lookbackDays",
        "type": "uint256"
      }
    ],
    "name": "getAggregatedEthFees",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "total",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "lookbackDays",
        "type": "uint256"
      }
    ],
    "name": "getAggregatedPlays",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "total",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "lookbackDays",
        "type": "uint256"
      }
    ],
    "name": "getAggregatedWelephantBuybacks",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "total",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getAllLifetimeSquareWins",
    "outputs": [
      {
        "internalType": "uint256[16]",
        "name": "wins",
        "type": "uint256[16]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "lookbackDays",
        "type": "uint256"
      }
    ],
    "name": "getDailyStatsForChart",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "dayIndices",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ethFees",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "welephantBuybacks",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "plays",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "uniquePlayers",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "fromDay",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "toDay",
        "type": "uint256"
      }
    ],
    "name": "getDailyStatsForRange",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "dayIndices",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ethFees",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "welephantBuybacks",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "plays",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "uniquePlayers",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getLeaderboardSize",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerAmountPerSquare",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerRoundData",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "bitmask",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amountPerSquare",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "index",
        "type": "uint256"
      }
    ],
    "name": "getPlayerRoundIdAt",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerRoundIdCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerRoundIds",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getPlayerRoundInfo",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPlay",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ethWon",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantWon",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "won",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "squareBitmask",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "amountPerSquare",
            "type": "uint256"
          }
        ],
        "internalType": "struct GameHistoryTypes.PlayerRoundInfo",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getPlayerRoundSummary",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "totalPlay",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "ethWon",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "welephantWon",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "won",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "squareBitmask",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerSquareBitmask",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerStats",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "ethSpent",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "roundsParticipated",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "roundsWon",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ethWon",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantWon",
            "type": "uint256"
          }
        ],
        "internalType": "struct GameHistoryTypes.PlayerStats",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "count",
        "type": "uint256"
      }
    ],
    "name": "getRecentRoundSummaries",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint40",
            "name": "roundId",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "closingBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantBoughtBack",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "paydayAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winnerPayout",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributed",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "winningSquare",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "totalPlayers",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "totalWinners",
            "type": "uint32"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          }
        ],
        "internalType": "struct GameHistoryTypes.RoundSummary[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "role",
        "type": "bytes32"
      }
    ],
    "name": "getRoleAdmin",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getRoundCore",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "startTime",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "endTime",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "startBlock",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "endBlock",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "closingBlock",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "winningSquare",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          },
          {
            "internalType": "bool",
            "name": "hasMinPlayers",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "participantCount",
            "type": "uint256"
          }
        ],
        "internalType": "struct IGameHistory.RoundCore",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getRoundIdToSummaryIndex",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "index",
        "type": "uint256"
      }
    ],
    "name": "getRoundParticipantAt",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getRoundParticipantCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getRoundSummaries",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint40",
            "name": "roundId",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "closingBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantBoughtBack",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "paydayAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winnerPayout",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributed",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "winningSquare",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "totalPlayers",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "totalWinners",
            "type": "uint32"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          }
        ],
        "internalType": "struct GameHistoryTypes.RoundSummary[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getRoundSummary",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint40",
            "name": "roundId",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "closingBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantBoughtBack",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "paydayAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winnerPayout",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributed",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "winningSquare",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "totalPlayers",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "totalWinners",
            "type": "uint32"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          }
        ],
        "internalType": "struct GameHistoryTypes.RoundSummary",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getRoundWinningSquare",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "square",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getSquarePlayerAmount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "square",
        "type": "uint256"
      }
    ],
    "name": "getSquarePlayerCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "square",
        "type": "uint256"
      }
    ],
    "name": "getSquareTotal",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "n",
        "type": "uint256"
      }
    ],
    "name": "getTopPlayersByEthWon",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "players",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ethWonAmounts",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTopPlayersByEthWonUnsorted",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "players",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ethWonAmounts",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalRoundSummaries",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "role",
        "type": "bytes32"
      },
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "grantRole",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "hasParticipated",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "role",
        "type": "bytes32"
      },
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "hasRole",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "incrementPlayerRoundsParticipated",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "incrementRoundId",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "newRoundId",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "initializeRound",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "isInLeaderboard",
    "outputs": [
      {
        "internalType": "bool",
        "name": "inLeaderboard",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "rank",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "square",
        "type": "uint256"
      }
    ],
    "name": "lifetimeSquareWins",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "paydayDistributionPercent",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "paydayFund",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "recordDailyEthFees",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "recordDailyWelephantBuyback",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "squareBitmask",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amountPerSquare",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "numSquares",
        "type": "uint256"
      }
    ],
    "name": "recordPlayerPlay",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "role",
        "type": "bytes32"
      },
      {
        "internalType": "address",
        "name": "callerConfirmation",
        "type": "address"
      }
    ],
    "name": "renounceRole",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "role",
        "type": "bytes32"
      },
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "revokeRole",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "ethWon",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "welephantWon",
        "type": "uint256"
      }
    ],
    "name": "setPlayerRoundWin",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "closingBlock",
        "type": "uint256"
      }
    ],
    "name": "setRoundClosingBlock",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "startTime",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "endTime",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "startBlock",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "endBlock",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "closingBlock",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "winningSquare",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          },
          {
            "internalType": "bool",
            "name": "hasMinPlayers",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "participantCount",
            "type": "uint256"
          }
        ],
        "internalType": "struct IGameHistory.RoundCore",
        "name": "core",
        "type": "tuple"
      }
    ],
    "name": "setRoundCore",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "endBlock",
        "type": "uint256"
      }
    ],
    "name": "setRoundEndBlock",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "finalized",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "winningSquare",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "isPayday",
        "type": "bool"
      },
      {
        "internalType": "bool",
        "name": "isSingleWinner",
        "type": "bool"
      },
      {
        "internalType": "address",
        "name": "singleWinner",
        "type": "address"
      }
    ],
    "name": "setRoundFinalization",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "finalized",
        "type": "bool"
      }
    ],
    "name": "setRoundFinalized",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "hasMinPlayers",
        "type": "bool"
      }
    ],
    "name": "setRoundHasMinPlayers",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "singleWinner",
        "type": "address"
      }
    ],
    "name": "setRoundSingleWinner",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "startTime",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "endTime",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "startBlock",
        "type": "uint256"
      }
    ],
    "name": "setRoundTiming",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalEthPaidOut",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalUniquePlayers",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalWelephantPaidOut",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint32",
        "name": "totalWinners",
        "type": "uint32"
      }
    ],
    "name": "updateRoundSummaryWinners",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
] as const;
